const digiLayer = window.digiLayer || new class {

    data = {};
    #store = null;
    #app = null;

    setStore (store) {
        this.#store = store;
    }

    setApp (app) {
        this.#app = app;
    }

    cartState () {
        return this.#store.getters['catalog/getCartData']?.items?.reduce((acc, item) => {
            acc[item.product_id] = item.quantity;
            return acc;
        }, {});
    }

    addToCart (offer_id, amount) {

        if (!this.data[`addToCart-${offer_id}`]) {
            this.data[`addToCart-${offer_id}`] = { amount : 0, timeout : null };
        }

        if (this.data[`addToCart-${offer_id}`]) {
            clearTimeout(this.data[`addToCart-${offer_id}`].timeout);
        }

        if (amount) {
            this.data[`addToCart-${offer_id}`].amount += amount;
        }
        else {
            this.data[`addToCart-${offer_id}`].amount = 0;
        }

        return new Promise(( resolve, reject ) => {
            this.data[`addToCart-${offer_id}`].timeout = setTimeout(() => {
                if (!this.data[`addToCart-${offer_id}`].amount) {
                    // полностью удаляем товар из корзины
                    this.removeFromCart(offer_id)
                        .then(() => resolve({ result : true }))
                        .catch(() => reject({ result : false }));
                }
                else {
                    this.#store.dispatch('catalog/addToCart', { id: offer_id, source: 'diginetica' })
                        .then(res => {
                            if (res.success) {
                                this.#app.$refs.popupAddedToCart?.open();
                                resolve({ result : true });
                            }
                            else {
                                reject({ result : false });
                            }
                        })
                        .catch(() => reject({ result : false }));
                }
                this.data[`addToCart-${offer_id}`] = null;
            }, 600);
        });
    }

    removeFromCart (offer_id) {
        return new Promise((resolve, reject) => {
            let item = this.#store.getters['catalog/getCartData']?.items?.find(o => o.product_id == offer_id);
            if (item) {
                this.#store.dispatch('catalog/removeFromCart', item.id)
                    .then(() => resolve({ result : true }))
                    .catch(() => reject({ result : false }));
            }
            else {
                reject({ result : false });
            }
        });
    }

    wishlistState () {
        return this.#store.getters['catalog/getFavorites'].map(id => id);
    }

    addToWishlist (offer_id) {
        return new Promise((resolve) => {
            this.#store.dispatch('catalog/toggleFavorites', offer_id)
                .then(async () => {
                    this.#app.$refs.popupAddedToFav?.open();
                    resolve({ result : true });
                });
        });
    }

    removeFromWishlist (offer_id) {
        return new Promise((resolve) => {
            this.#store.dispatch('catalog/toggleFavorites', offer_id)
                .then(async () => {
                    alert('Товар удален из избранного');
                    resolve({ result : true });
                });
        });
    }

}

export default digiLayer;